//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  data(){
    return {
      isShowRefresh: false,
      isKeepAlive: false
    }
  },
  created() {
    this.isShowRefresh = window.location.hostname == 'm.ytgrading.com' ? false : true
  },
  watch: {
    '$route': 'routeChange'
  },
  methods: {
    routeChange() {
      document.title = this.$route.meta.title;
      this.isKeepAlive = this.$route.meta.keepAlive
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue